import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from 'react-bootstrap/Button';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';

import TowerAPI from '../../api/TowerAPI';
import PropertyAPI from '../../api/PropertyAPI';
import ApiUiController from '../../controller/ApiUiController';
import InnerRoomList from '../room/InnerRoomList';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import TowerConst from '../../util/TowerConst';
import withRouter from '../../util/WithRouter';
import Display from '../../util/Display';
import RoomPopup from '../room/RoomPopup';

class TowerPreview extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.tower_details;
    this.id = parseInt(props.match.params.towerId);
    this.projectId = parseInt(props.location.search.substr(props.location.search.indexOf('=') + 1));
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.lastIndexOf('/'));
    this.state = { inApiCall: true, popup: null, room: null };
    this.room = { id:0,room_name: 0, property: 0, room_status: 0, project_id: this.projectId , tower_id: this.id, floor_no: 0 };
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.ContactList = Util.isAllow(this.models.contact.permission, Const.PermView);
    this.ContactAdd = Util.isAllow(this.models.contact.permission, Const.PermAdd);
    
    this.DocList = Util.isAllow(this.models.document.permission, Const.PermView);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);

    this.HideAllContact = Util.isAllow(this.models.project.permission, Const.HideAllContact);
    this.HideOthersContact = Util.isAllow(this.models.project.permission, Const.HideOtherContact);
    this.HideOtherContactView = false;
  }

  UNSAFE_componentWillReceiveProps(props) {
    TowerAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  }

  componentDidMount() {
    PropertyAPI.getInnerProjectList(this.projectId, this.onPropertyReceived, () => {}); 
  }

  onPropertyReceived = res => {
    const options = res.data.map(property => {
      let label = Display.FieldValue(property, 'property_type', this.models.property.fields);
        label += "-" + property.build_area + "-" + property.price;
      return { label, value: property.id };
    });
    this.models.room.fields.property.options = options;
    if(this.id !== 0) {
      TowerAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
    } 
  }
  onReceived = res => {
    this.tower = res;
    if(this.HideOthersContact) {
      if(!this.project.responsible_person.includes('~'+this.user.user_id+'~')){ this.HideOtherContactView = true;}
    }
    this.setState({ ...this.state, inApiCall: false });
  }

  onUpdate = () => {
    this.setState({ ...this.state, inApiCall: true });
    TowerAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  };
  onDelete = () => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.lead)}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      TowerAPI.delete(this.lead.id, this.onDeleteSuccess,
        this.props.failure, this.props.logout);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Project deleted successfully', 'success');
    this.props.navigate('/project');
  }

  updateMater = () => {
    this.setState({ inApiCall: true, popup: null });
    TowerAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  }

  showDetails = (model, field) => {
    if(field === TowerConst.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if(field === TowerConst.Contact) {
      this.props.navigate(`/contact/preview/${model}`);
      return;
    }
  }
  showPopUp = (model, field) => {
    let tmp = { ...this.state };
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp});
  }

  hidePopUp = () => this.setState({ ...this.state, popup: TowerConst.Refresh});
  
  render() {
    const data = [];
    const ReportName = Display.ModelLabelValue("project", this.projectId) + ' - ' 
      + (this.tower ? this.tower.tower_name : '') + ' Configuration.csv';

    return (
      <section className="previewpage"> 
        <ApiUiController inApiCall={this.state.inApiCall}>
         
        <RoomPopup show={this.state.popup === TowerConst.Room} onHide={this.hidePopUp}
          room={this.state.room} failure={this.props.failure} logout={this.props.logout}
          reload={this.updateMater} model_no={Const.Lead} model_id={this.id} tower={this.tower}
          project={this.projectId} model={this.models.room} />

          <div className="container-fluid">  
            <div className="row lead-mt">
              <div className="col-md-4">
                <div className="title_page">
                  <h2>Tower - {this.tower ? this.tower.tower_name : ''}</h2>
                </div>
              </div>
              <div className="col-md-4 lead-btns-col">
                <span className="action-btns-lg">
                  <table>
                    <tbody>
                      <tr>
                        <th><h3>Project:</h3></th>
                        <td><h3>{Display.ModelLabelValue("project", this.projectId)}</h3></td>
                      </tr>
                    </tbody>
                  </table> 
                </span>
              </div>
              <div className="col-md-4">
                <Link  className="buttons primary" onClick={()=>{this.showPopUp(this.room,TowerConst.Room)}}>
                  Add Rooms
                </Link>
                <Link to={`${this.base}/mass-update/${this.id}?project=${this.projectId}`} className="buttons update">
                  Mass Update
                </Link>
                <CSVLink data={data} filename={ReportName}><Button className="buttons btn-success">Export</Button></CSVLink>
              </div>
            </div>

            <div className="row tablesrow">
              <div className="col-md-12">
                  <InnerRoomList id={this.id} type={Const.Tower} reload={this.updateMater}
                    edit={this.showPopUp} logout={this.props.logout} failure={this.props.failure} 
                    model_no={Const.Project} model_id={this.id} project={this.project_id}
                    model={this.models.room} />
              </div>
            </div>
          </div>
        </ApiUiController>
      </section>
    );
  }
}
export default withRouter(TowerPreview);